import React from "react";
import PropTypes from "prop-types";

export const LabelledCheckbox = ({ labelText, id, groupName, checked, onChange, customWidth = "auto" }) => {
    return (
        <div style={{ position: "relative", width: customWidth }}>
            <input
                className="checkbox-group__input"
                id={id}
                type="checkbox"
                name={groupName}
                onChange={onChange}
                checked={checked}
            />
            <label className="checkbox-group__label h6" htmlFor={id}>
                {labelText}
            </label>
        </div>
    );
};

LabelledCheckbox.propTypes = {
    labelText: PropTypes.string.isRequired,
    groupName: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    changeEvent: PropTypes.func,
};
